
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useStrategyActions = () => {
  const handleSelectStrategy = (strategyName: string) => {
    console.log("Selected strategy:", strategyName);
    // Implementation for selecting a strategy
  };

  const handleUnfollowStrategy = async (followRecordId: string) => {
    try {
      console.log("Attempting to unfollow strategy with follow record ID:", followRecordId);
      
      const { error } = await supabase
        .from('followed_strategies')
        .delete()
        .eq('id', followRecordId);

      if (error) {
        console.error("Error unfollowing strategy:", error);
        toast.error("Failed to unfollow strategy");
        return false;
      }

      toast.success("Strategy unfollowed successfully");
      return true;
    } catch (error) {
      console.error("Unexpected error unfollowing strategy:", error);
      toast.error("Something went wrong");
      return false;
    }
  };

  const handleManageSubscription = () => {
    console.log("Managing subscription");
    // Implementation for managing subscription
  };

  return {
    handleSelectStrategy,
    handleUnfollowStrategy,
    handleManageSubscription
  };
};
